import locale from "../locale";
const globalObject = {
  language: 'vi',
  vi: {
    agree: 'Đồng ý',
    cancel: 'Hủy',
    close: 'Đóng',
    confirm: 'Xác nhận',
    error: 'Lỗi',
    unknownError: 'Lỗi chưa xác định',
    no: 'Không',
    noDataText: 'Không có dữ liệu',
    notify: 'Thông báo',
    ok: 'Đồng ý',
    showLess: 'Rút gọn',
    showMore: 'Xem thêm',
    yes: 'Có',
    warning: 'Cảnh Báo',
    // attachment
    dropFileHere: 'Kéo và thả tập tin đính kèm vào đây',
    deleteNotifyText: 'Bạn có chắc muốn xóa (những) đính kèm này?',
    attachText: 'Đính kèm',
    noFileText: 'Không có file đính kèm',
    byName: 'Theo tên',
    byType: 'Theo loại',
    bySize: 'Theo kích thước',
    byDate: 'Theo ngày',
    byOwner: 'Theo người tạo',
    errorDefault: {
      maxFile: ' vượt quá số lượng cho phép!',
      maxSize: ' quá dung lượng cho phép!',
      fileType: ' không đúng định dạng!',
      existingFile: ' đã được đính kèm!'
    },
    // Paging
    lineNumber: 'Số dòng',
    total: 'Tổng',
    // Transfer
    choices: 'lựa chọn',
    chosen: 'được chọn',
    selected: 'Đã chọn',
    // Date Picker
    helperInvalid: 'Sai định dạng',
    helperValid: 'Phù hợp',
    label: 'Thời gian',
    weekdaysLong: ['Hai', 'Ba', 'Tư', 'Năm', 'Sáu', 'Bảy', 'CN'],
    weekdaysShort: ['H', 'B', 'T', 'N', 'S', 'B', 'C'],
    // Time Picker
    months: {
      full: ['tháng 01', 'tháng 02', 'tháng 03', 'tháng 04', 'tháng 05', 'tháng 06', 'tháng 07', 'tháng 08', 'tháng 09', 'tháng 10', 'tháng 11', 'tháng 12'],
      notFull: ['thg 01', 'thg 02', 'thg 03', 'thg 04', 'thg 05', 'thg 06', 'thg 07', 'thg 08', 'thg 09', 'thg 10', 'thg 11', 'thg 12']
    },
    days: {
      full: ['chủ nhật', 'thứ hai', 'thứ ba', 'thứ tư', 'thứ năm', 'thứ sáu', 'thứ bảy'],
      notFull: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7']
    },
    night: 'đêm',
    day: 'ngày',
    month: 'tháng',
    year: 'năm',
    // Localize
    selectAll: 'Chọn tất cả',
    thisFieldIsRequired: 'Trường này bắt buộc nhập',
    validate: {
      isEmail: 'Email không hợp lệ',
      isNotEmptyString: 'Phải chứa ít nhất một ký tự',
      isNotEmptyObject: 'Phải chứa ít nhất một thuộc tính',
      isNotEmptyArray: 'Phải chứa ít nhất một phần tử',
      invalidInput: 'Giá trị đầu vào chưa đúng',
      max: 'Vượt quá giá trị tối đa cho phép',
      min: 'Chưa đạt giá trị tối thiểu cho phép',
      required: 'Trường này bắt buộc nhập'
    },
    inputPlaceholder: 'Nhập',
    dropdownPlaceholder: 'Chọn'
  },
  en: {
    agree: 'Agree',
    cancel: 'Cancel',
    close: 'Close',
    confirm: 'Confirm',
    error: 'Error',
    unknownError: 'Unknown Error',
    no: 'No',
    noDataText: 'No data',
    notify: 'Notify',
    ok: 'OK',
    showLess: 'Show less',
    showMore: 'Show more',
    yes: 'Yes',
    warning: 'Warning',
    // attachment
    dropFileHere: 'Drop files here',
    deleteNotifyText: 'Are you sure you want to delete this attachment(s)?',
    attachText: 'Attachment',
    noFileText: 'No attachments',
    byName: 'By name',
    byType: 'By type',
    bySize: 'By size',
    byDate: 'By date',
    byOwner: 'By owner',
    errorDefault: {
      maxFile: ' exceeded the allowed number!',
      maxSize: ' is/are too large to allow!',
      fileType: ' is/are not in the correct format!',
      existingFile: ' have been attached!'
    },
    // Paging
    lineNumber: 'Items per page',
    total: 'Total',
    // Transfer
    choices: 'choices',
    chosen: 'chosen',
    selected: 'selected',
    // Date Picker
    helperInvalid: 'Invalid',
    helperValid: 'Valid',
    label: 'Time',
    weekdaysLong: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    weekdaysShort: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
    // Time Picker
    months: {
      full: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      notFull: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    },
    days: {
      full: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      notFull: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    },
    night: 'night',
    day: 'day',
    month: 'month',
    year: 'year',
    // Localize
    selectAll: 'Select all',
    thisFieldIsRequired: 'This field is required',
    validate: {
      isEmail: 'Email invalid',
      isNotEmptyString: 'Must not be empty',
      isNotEmptyObject: 'Must contain at least one attribute',
      isNotEmptyArray: 'Must contain at least one element',
      invalidInput: 'Input value is not correct',
      max: 'Exceeds the maximum value allowed',
      min: 'The minimum allowed value has not been reached',
      required: 'This field is required'
    },
    inputPlaceholder: 'Type something',
    dropdownPlaceholder: 'Select'
  },
  //Global variable
  delayOnInput: 500,
  maxSizeUpload: Infinity,
  //Components
  components: {
    attachment: {
      defaultProps: {
        allowSort: true,
        className: '',
        data: [],
        disabled: false,
        maxFile: Infinity,
        multiple: true,
        style: {},
        viewType: 'detail'
      }
    }
  }
};
export const getGlobal = (key, language = locale.get()) => {
  var _globalObject$languag;
  if (Array.isArray(key)) {
    let result = key[0] === 'components' ? globalObject : globalObject[language];
    for (let i = 0; i < key.length; i++) {
      if (!result[key[i]]) {
        return null;
      }
      result = result[key[i]];
    }
    return result;
  }
  return globalObject[key] || ((_globalObject$languag = globalObject[language]) === null || _globalObject$languag === void 0 ? void 0 : _globalObject$languag[key]);
};
export const setGlobal = global => {
  if (global && typeof global === 'object') {
    const themeKeys = Object.keys(global);
    themeKeys.forEach(key => {
      overrideGlobal(global, globalObject, key);
    });
  }
};
const overrideGlobal = (newGlobal, ingredient, key) => {
  const newGlobalValue = newGlobal[key];
  const rootValue = ingredient[key];
  if (typeof newGlobalValue === 'object' && typeof rootValue === 'object') {
    const newGlobalKeys = Object.keys(newGlobalValue);
    newGlobalKeys.forEach(newKey => {
      if (newGlobalValue[newKey] && rootValue[newKey]) {
        overrideGlobal(newGlobalValue, rootValue, newKey);
      }
    });
  } else {
    globalObject[key] = newGlobalValue;
  }
};
export default globalObject;